import { motion, useReducedMotion } from "framer-motion";
import { Section, Headline, Reveal } from "@/components/primitives";
import { tools } from "@/config";
import { stagger, item, viewport } from "@/lib/motion";

export default function Tools() {
  const reduce = useReducedMotion();
  return (
    <Section id="tools" tone="noir">
      <Reveal>
        <Headline>{tools.headline}</Headline>
        <div className="hairline mt-5 w-16" aria-hidden="true" />
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
        {tools.groups.map((g, gi) => (
          <Reveal key={g.label} delay={gi * 0.08} className="h-full">
            <div data-testid={`tool-group-${gi}`} className="card flex h-full flex-col rounded-xl p-7">
              <div className="flex items-center gap-3 border-b border-cream/8 pb-4">
                <span className="h-px w-6 bg-gold/70" aria-hidden="true" />
                <span className="label !text-gold">{g.label}</span>
              </div>
              <motion.ul
                variants={reduce ? undefined : stagger(0.08)} initial={reduce ? false : "hidden"} whileInView="show" viewport={viewport}
                className="mt-5 grid grid-cols-2 gap-2.5"
              >
                {g.items.map((t) => (
                  <motion.li
                    key={t}
                    variants={item}
                    data-testid="tool-chip"
                    className="flex h-11 items-center justify-center rounded-md border border-cream/12 bg-cream/[0.03] px-3 text-center text-sm text-cream/85 transition-colors hover:border-gold/50 hover:text-gold"
                  >
                    {t}
                  </motion.li>
                ))}
              </motion.ul>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
